import posthog from "posthog-js";
import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";

/**
 * Fetches full user details from AppUser.GetUser.
 * When userId is omitted, the API returns the logged-in user.
 */
export async function fetchFullUserDetails(userId) {
  try {
    const { AppUser } = config.REST_API;
    const url = userId ? `${AppUser.GetUser}?userId=${userId}` : AppUser.GetUser;
    const response = await axiosBasic.get(url);

    if (!response?.data) return null;

    const responseData = response.data;

    if (responseData.success !== undefined) {
      if (responseData.success && responseData.data) {
        return responseData.data;
      }
      if (responseData.success && !responseData.data) {
        const { success, message, ...userData } = responseData;
        return Object.keys(userData).length > 0 ? userData : null;
      }
    }

    if (responseData.data) {
      return responseData.data;
    }

    const { success, message, ...userData } = responseData;
    return Object.keys(userData).length > 0 ? userData : null;
  } catch (error) {
    if (typeof posthog !== "undefined" && posthog.capture) {
      posthog.capture("userProfileFetchDetails", {
        type: "exception",
        success: false,
        reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
        status: error?.response?.status,
      });
    }
    return null;
  }
}
